const COORDINATES = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F']

export default class LevelSelectState extends Phaser.State {
  create () {
    this.add.bitmapText(16, 16, 'monospace', 'LEVEL SELECT', 9)

    this.currentLevel = parseInt(window.localStorage.getItem('level'))

    this.items = []
    for (var i = 0; i < 22; i++) {
      const text = toHex(i)
      const x = i % 8
      const y = Math.floor(i / 8)
      this.items.push(this.add.bitmapText(16 + 20 * x, 50 + 14 * y, 'monospace', text, 9))
    }

    this.selectedItem = 0
    this.updateItems()

    const onUp = () => {
      if (this.selectedItem - 8 >= 0) {
        this.selectedItem -= 8
      }
      this.updateItems()
    }

    const onDown = () => {
      if (this.selectedItem + 8 <= this.currentLevel) {
        this.selectedItem += 8
      }
      this.updateItems()
    }

    const onLeft = () => {
      if (this.selectedItem - 1 >= 0) {
        this.selectedItem--
      }
      this.updateItems()
    }

    const onRight = () => {
      if (this.selectedItem + 1 <= this.currentLevel) {
        this.selectedItem++
      }
      this.updateItems()
    }

    const upKey = this.game.input.keyboard.addKey(Phaser.Keyboard.UP)
    upKey.onDown.add(() => { onUp() })
    const wKey = this.game.input.keyboard.addKey(Phaser.Keyboard.W)
    wKey.onDown.add(() => { onUp() })

    const downKey = this.game.input.keyboard.addKey(Phaser.Keyboard.DOWN)
    downKey.onDown.add(() => { onDown() })
    const sKey = this.game.input.keyboard.addKey(Phaser.Keyboard.S)
    sKey.onDown.add(() => { onDown() })

    const leftKey = this.game.input.keyboard.addKey(Phaser.Keyboard.LEFT)
    leftKey.onDown.add(() => { onLeft() })
    const aKey = this.game.input.keyboard.addKey(Phaser.Keyboard.A)
    aKey.onDown.add(() => { onLeft() })

    const rightKey = this.game.input.keyboard.addKey(Phaser.Keyboard.RIGHT)
    rightKey.onDown.add(() => { onRight() })
    const dKey = this.game.input.keyboard.addKey(Phaser.Keyboard.D)
    dKey.onDown.add(() => { onRight() })

    const onEnter = () => {
      this.state.start('text', true, false, this.selectedItem)
    }

    const enterKey = this.game.input.keyboard.addKey(Phaser.Keyboard.ENTER)
    enterKey.onDown.add(() => { onEnter() })
    const mKey = this.game.input.keyboard.addKey(Phaser.Keyboard.M)
    mKey.onDown.add(() => { onEnter() })

    const escapeKey = this.game.input.keyboard.addKey(Phaser.Keyboard.ESC)
    escapeKey.onDown.add(() => { this.state.start('init', true, false, 0) })
  }

  updateItems () {
    for (const i in this.items) {
      let alpha
      if (i > this.currentLevel) {
        alpha = 0.2
      } else {
        alpha = ((i == this.selectedItem) ? 1 : 0.5)
      }
      this.items[i].alpha = alpha
    }
  }
}

function toHex (value) {
  const high = Math.floor(value / 16)
  const low = value % 16

  return `${COORDINATES[high]}${COORDINATES[low]}`
}
